"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var commons_1 = require("../commons");

var DataObjectConverter_1 = require("./DataObjectConverter");

var ProjectableDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProjectableDataConverter, _DataObjectConverter_);

  function ProjectableDataConverter() {
    _classCallCheck(this, ProjectableDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProjectableDataConverter).apply(this, arguments));
  }

  _createClass(ProjectableDataConverter, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      throw new Error('Unsupported');
    }
  }]);

  return ProjectableDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProjectableDataConverter = ProjectableDataConverter;

function testCompilationNotRun() {
  var c = commons_1.UNIMPLEMENTED();
  var d = c.project(['a', 'b']);
}